'use client';
import React, { useEffect, useRef, useState } from "react"
import { useShopify } from "../../hooks/useShopify";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import cssStyles from "./shopify_cart.module.scss";
import { CART_TOKEN, GCART_TOKEN } from "@/utils";
import { CartInfo, fetchCartDetails, updateCartData } from "@/utils/useUserInfo";
import QuantityBox from "../quantity";

interface LineItemProps {
	userInfo: any;
	setCartItem: any;
	upatedIfDeletedCartItem: any;
	productData: any;
	isCartItemDeleted: any;
	cartItem: any;
	setCartCookie: any;
	updateToInventoryQuantity: any;
}

const LineItem: React.FC<LineItemProps> = ({userInfo, updateToInventoryQuantity, setCartCookie, cartItem, setCartItem, upatedIfDeletedCartItem, productData, isCartItemDeleted}) => {

	console.log("----- LineItem Start--------")
	const prevTotalCartQuantity = useRef(0);
	const { checkoutState, updateQuantities, updateQuantity, removeLineItem, updateDB, createNewCheckOutAndaddVariant, cartQuantity } = useShopify();


	/**
	 * fetching the db cart items and creating new cart with db cartitems, 
	 * if cart expires and quantities dont update after user inc/decrement qunatities
	 */
	useEffect(()=>{
			setTimeout(()=>{
				//@ts-ignore
			if(checkoutState && checkoutState.lineItems && prevTotalCartQuantity.current > 0 && prevTotalCartQuantity.current == cartQuantity && window.nestingale && !window.nestingale.apiTriggered){	
				(async ()=>{
					if(userInfo && userInfo.cId){
						fetchCartDetails(userInfo.cId).then((cartInfo: CartInfo) => {
							if (cartInfo.error) {
								return cartInfo;
							}
							localStorage.setItem('cartData', JSON.stringify(cartInfo));
							userInfo.crtD = cartInfo;
	
							const cartInfoItems = cartInfo.cartItems;
							if(cartInfoItems){
								const cartInfoItemsToAdd = cartInfoItems.flatMap((item:any) => {
									
									let dbProductData = productData.filter((eachItem: any)=>{
										return eachItem.productId == item.sku
									})

									let dbAvailableCount = 0;
									try{
										dbAvailableCount = dbProductData[0].availabilityCount;
									}catch(e){
										console.log(`sku=${item.sku}, availabilityCount not present ${dbProductData}`);
									}
									console.log(dbProductData);
									if(item.variantId != "no variant Id" && item.quantity < dbAvailableCount){
										return {
											variantId: item.variantId,
											quantity: item.quantity
										}
									}
								});
								//add all the guest variants to loggedIn user checkout
								createNewCheckOutAndaddVariant(null, cartInfoItemsToAdd);
								prevTotalCartQuantity.current=0;									
							}
							return cartInfo;
						});
					}
				})()
			}
			},0)
		},[checkoutState])


	/**
	 * once the cart is recreated update the DB with new cart with items for the logged in user
	 */
	useEffect(()=>{
		if(!updateDB){
			return;
		}
		try{											
			(async ()=>{
				//update the cart Data with even CartCount 0
				await updateCartData(userInfo,checkoutState,cartItem, setCartItem, true,isCartItemDeleted.current, upatedIfDeletedCartItem, true);
				setCartCookie(checkoutState.id);
				prevTotalCartQuantity.current=0;
			})();					
		}catch(e){
			console.log("Failed Saving the cartData",e)
		}
	},[updateDB])


	/**
	 * Update the cart items quantity based on the availability count if query param upiq is true which we receive from checkout page 
	 */
	useEffect(()=>{
		if(updateToInventoryQuantity && checkoutState && checkoutState.lineItems){	
			(async ()=>{
				if(userInfo && userInfo.cId){
					fetchCartDetails(userInfo.cId).then((cartInfo: CartInfo) => {
						if (cartInfo.error) {
							return cartInfo;
						}
						if(productData && productData.length > 0){
							  const lineItemsToUpdate = JSON.parse(JSON.stringify(
								checkoutState.lineItems.map((eachItem: any, index: number)=>{
									const productInfo = productData?.filter((eachProduct:any)=>{   
										return(eachItem.variant.sku == eachProduct.productId);
									})
									let quantity = eachItem.quantity
									if(parseInt(productInfo[0].availabilityCount) < eachItem.quantity){
										quantity = parseInt(productInfo[0].availabilityCount)
									}
									return { id: eachItem.id, quantity: quantity}
								})
							));

							updateQuantities(lineItemsToUpdate, checkoutState.id);							
						}
						return cartInfo;
					});
				}
			})()
		}
	},[updateToInventoryQuantity])

	function isCartIdPresent(){
		if(typeof window !== 'undefined'){
			//@ts-ignore
			let userCartId = userInfo?.crtD?.cartId || window.getCookie(CART_TOKEN);
			if(!userCartId || userCartId == 'null' || userCartId == 'undefined') {
				//@ts-ignore
				userCartId = window.getCookie(GCART_TOKEN);
			}
			
			if(!userCartId || 
				userCartId=="undefined" ||
				userCartId=="null"){
				window.location.href= `/login?next=${encodeURIComponent(window.location.href)}`;
				return false;
			}
			return true;
		}
		return false;
	}

	function decrementQuantity(lineItemId: any, lineItemQuantity: number, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		if(!isCartIdPresent()){
			return;	
		}
		const checkoutId = checkoutState.id
		const updatedQuantity = lineItemQuantity - 1

		prevTotalCartQuantity.current = lineItemQuantity;

		updateQuantity(lineItemId, updatedQuantity, checkoutId)
		
		const cartItem = JSON.parse(JSON.stringify(
			checkoutState.lineItems.filter((eachItem: any)=>{
				return eachItem.id == lineItemId
			})
		));
		if(cartItem.length>0){
			cartItem[0].quantity =  updatedQuantity as any;
			setCartItem(cartItem)
		}
	}
	//if no cartToken dont update / delete cart items
	function incrementQuantityByInput(lineItemId: any, sku : any,e: React.ChangeEvent<HTMLInputElement>) {
		e.preventDefault()
		if(!isCartIdPresent()){
			return;	
		}
		const checkoutId = checkoutState.id;
		let userInputquantity = parseInt(e.target.value) || 0;//xss will be converted to NAN

		let dbProductData = productData.filter((eachItem: any)=>{
			return eachItem.productId == sku
		});

		if(dbProductData.length > 0 && userInputquantity > dbProductData[0].availabilityCount){
			//userInputquantity = dbProductData[0].availabilityCount;
			return;
		}


		if(checkoutState && checkoutState.lineItems){
			const latestCount = checkoutState.lineItems.reduce((currentValue:number, eachItem:any) => {
				currentValue += (eachItem.quantity || 0);
				return currentValue;
			}, 0);
			prevTotalCartQuantity.current = latestCount
		}

		updateQuantity(lineItemId, userInputquantity, checkoutId)
		if(userInputquantity<=0){
			upatedIfDeletedCartItem(true);
		}
		const cartItem = JSON.parse(JSON.stringify(
			checkoutState.lineItems.filter((eachItem: any)=>{
				return eachItem.id == lineItemId
			})
		));
		if(cartItem.length>0){
			cartItem[0].quantity =  userInputquantity as any;
			setCartItem(cartItem)
		}
	}

	function incrementQuantity(lineItemId: any, lineItemQuantity: number, sku:any, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault()
		if(!isCartIdPresent()){
			return;	
		}
		let dbProductData = productData.filter((eachItem: any)=>{
			return eachItem.productId == sku
		})
		const checkoutId = checkoutState.id
		let updatedQuantity = lineItemQuantity + 1

		prevTotalCartQuantity.current = lineItemQuantity;
		

		if(dbProductData.length > 0 && updatedQuantity > dbProductData[0].availabilityCount){
			//updatedQuantity = lineItemQuantity;
			return;
		}
		updateQuantity(lineItemId, updatedQuantity, checkoutId)
		const cartItem = JSON.parse(JSON.stringify(
			checkoutState.lineItems.filter((eachItem: any)=>{
				return eachItem.id == lineItemId
			})
		));
		if(cartItem.length>0){
			cartItem[0].quantity =  updatedQuantity as any;
			setCartItem(cartItem)
		}
	}

	function deleteLineItem(lineItemId: any, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault()
		if(!isCartIdPresent()){
			return;	
		}
		const checkoutId = checkoutState.id
		removeLineItem(checkoutId, lineItemId)
		upatedIfDeletedCartItem(true);
		setCartItem(
			checkoutState.lineItems.filter((eachItem: any)=>{
				return eachItem.id == lineItemId
			})
		);
	}

	
	return (
			<TableContainer  className={cssStyles["cart-items-table-container"]}>
				<Table aria-label="all cart items">
					<TableHead>
					<TableRow>
						<TableCell>Product</TableCell>
						<TableCell>Quantity</TableCell>
						<TableCell></TableCell>
						<TableCell>Price</TableCell>
					</TableRow>
					</TableHead>
					<TableBody>
							{checkoutState.lineItems &&
							checkoutState.lineItems.map((lineItem: any, i:number) => {
							    if (lineItem.variant && lineItem.variant.sku) {


									const productInfo = productData?.filter((eachProduct:any)=>{   
										return(lineItem.variant.sku == eachProduct.productId);
									})
									

                                    return (
                                        <TableRow key={`${lineItem.title}` + i}>
                                            <TableCell>
                                                <div className={cssStyles["cart-item__info_container"]}>
                                                    <div className={cssStyles["cart-item__media"]}>
                                                        {lineItem.variant && lineItem.variant.image ? (
                                                            <a href={`/product/${lineItem.variant.sku}`}>
                                                            <img
                                                                src={lineItem.variant.image.src}
                                                                alt={`${lineItem.title} product shot`}
                                                            />
                                                            </a>
                                                        ) : null}
                                                    </div>
                                                    <div className={cssStyles["cart-item__info"]}>
                                                        <a href={`/product/${lineItem.variant.sku}`}>
                                                            <div className={cssStyles["cart-item_name"]}>{lineItem.title}</div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className={cssStyles["cart-item-inc-dec-section"]} style={{flexDirection: "column"}}>
													<QuantityBox
														decrement={decrementQuantity} 
														increment={incrementQuantity}
														incrementByInput={incrementQuantityByInput} 
														id={lineItem.id} 
														quantity={lineItem.quantity}
														variant={lineItem.variant} 
														availabilityCount={productInfo[0]?.availabilityCount}/>
                                                </div>
                                            </TableCell>
											<TableCell>
												<IconButton color="error" aria-label="cart item remove" onClick={(e:any) => deleteLineItem(lineItem.id, e)}>
													<DeleteIcon  className={cssStyles["icon"]} style={{fontSize: "22px"}}/>
												</IconButton>
											</TableCell>
                                            <TableCell>
                                                <span style={{ textDecoration: "line-through"}}>{lineItem.variant.price.amount != lineItem?.variant?.compareAtPriceV2?.amount ? <>$ {lineItem.quantity * lineItem?.variant?.compareAtPriceV2?.amount}<br/></>  : ""}</span>
                                                <span className={cssStyles["cart-item__price"]}>
                                                    $ {(lineItem.quantity * lineItem.variant.price.amount).toFixed(2)}
                                                </span>
                                            </TableCell>
                                        </TableRow>
                                    )
								}
							})}
					</TableBody>
				</Table>
			</TableContainer>)
}
 
export default LineItem;
